import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.regexp.to-string.js";
import { getPayItemList } from '@/api/payItem';
export var itemPay = {
  namespaced: true,
  state: {
    isInit: 0,
    payKv: {},
    payRmbKv: {}
  },
  mutations: {
    setPayKv: function setPayKv(state, payMap) {
      state.isInit = 1;
      state.payKv = payMap;
    },
    setPayRmbKv: function setPayRmbKv(state, payRmbKv) {
      state.payRmbKv = payRmbKv;
    }
  },
  actions: {
    getPay: function getPay(_ref) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var commit, state, res, payMap, payRmbKv;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit, state = _ref.state;
              if (!(state.isInit == 0)) {
                _context.next = 6;
                break;
              }
              _context.next = 4;
              return getPayItemList();
            case 4:
              res = _context.sent;
              if (res.code == 0) {
                payMap = {};
                payRmbKv = {};
                res.data.list.forEach(function (val) {
                  payMap[val.pay_item_id.toString()] = val.pay_item_name;
                  payRmbKv[val.pay_item_id.toString()] = val.pay_item_price / 100;
                });
                // dictionaryMap[res.data.resysDictionary.type] = dict
                commit("setPayKv", payMap);
                commit("setPayRmbKv", payRmbKv);
                // return state.dictionaryMap[type]
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  },
  getters: {
    payMap: function payMap(state) {
      return state.payKv;
    },
    payRmbMap: function payRmbMap(state) {
      return state.payRmbKv;
    }
  }
};